/**
 * Icons the browser script adds to the page: Phosphor (MIT,
 * @phosphor-icons/core 2.1.1, bold weight), the same as the server's.
 */
const phosphor = (path: string): string =>
  `<svg viewBox="0 0 256 256" fill="currentColor" aria-hidden="true" focusable="false"><path d="${path}"/></svg>`;

export const caretLeftIcon = phosphor(
  "M168.49,199.51a12,12,0,0,1-17,17l-80-80a12,12,0,0,1,0-17l80-80a12,12,0,0,1,17,17L97,128Z",
);

export const caretRightIcon = phosphor(
  "M184.49,136.49l-80,80a12,12,0,0,1-17-17L159,128,87.51,56.49a12,12,0,1,1,17-17l80,80A12,12,0,0,1,184.49,136.49Z",
);
